// src/redux/profileCountSlice.js

import { createSlice } from "@reduxjs/toolkit";

const profileCountSlice = createSlice({
  name: "profileCount",
  initialState: {
    count: 0,
  },
  reducers: {
    setProfileCount: (state, action) => {
      state.count = action.payload;
    },
    incrementProfileCount: (state) => {
      state.count += 1;
    },
    decrementProfileCount: (state) => {
      state.count -= 1;
    },

  },
});

export const { setProfileCount, incrementProfileCount, decrementProfileCount } =
  profileCountSlice.actions;

export default profileCountSlice.reducer;
